module.exports = __webpack_public_path__ + "static/filter_none-07bb0b22ea8c0f07b62c239336766f6a.png";